export type InsuranceProvider = {
  id: string;
  insuranceType?: string;
  name?: string;
  registrationValidation?: InsuranceRegistrationValidation;
  visitValidation?: InsuranceVisitValidation;
};

export type InsuranceRegistrationValidation = {
  formSchema?: Record<string, any>;
  validatorConfig?: Record<string, any>;
};

export type InsuranceVisitValidation = {
  expiryStrategy: VisitExpiryStrategy;
  formSchema?: Record<string, any>;
  validatorConfig?: Record<string, any>;
};

export enum VisitExpiryStrategy {
  Midnight = "MIDNIGHT",
  UntilDischarged = "UNTIL_DISCHARGED",
}

export enum JSONSchemaFieldType {
  OBJECT = "object",
  STRING = "string",
  BOOLEAN = "boolean",
  NUMBER = "number",
  ARRAY = "array",
}

export enum DependentStatus {
  MEMBER = "member",
  DEPENDENT_SPOUSE = "dependentSpouse",
  DEPENDENT_CHILD = "dependentChild",
}

type EnumTitles = {
  enumTitles: string[];
};

export enum ValidationType {
  PATTERN = "pattern",
  REQUIRED = "required",
}

export type ErrorMessage = {
  [k in ValidationType]?: string;
};

export interface InsuranceProviderFormSchema {
  description: string;
  type: JSONSchemaFieldType;
  title: string;
  // TODO be removed once FE 'legacy' (non-MUI) dynamic forms no longer utilise the `properties` attribute
  properties: FieldDefinition[];
  orderedProperties: unknown;
}

export interface FieldDefinition {
  name: string;
  title: string;
  type: JSONSchemaFieldType;
  required?: boolean;
  pattern?: string;
  properties?: FieldDefinition[];
  orderedProperties?: OrderedFieldDefinition[];
  format?: string;
  enum?: string[];
  enumTitles?: string[];
}

export interface OrderedFieldDefinition {
  name: string;
  title: string;
  type: JSONSchemaFieldType;
  required?: boolean;
  pattern?: string;
  format?: string;
  enum?: string[];
  meta?: EnumTitles;
  enumTitles?: string[];
}

export interface InsuranceProviderValidatorConfig {
  errMessages: Record<string, ErrorMessage>;
}

export interface InsuranceProviderValidation {
  formSchema?: InsuranceProviderFormSchema;
  validatorConfig?: InsuranceProviderValidatorConfig;
}

export interface InsuranceProviderSchema
  extends Pick<InsuranceProvider, "id" | "insuranceType" | "visitValidation"> {
  name: string;
  registrationValidation: InsuranceProviderValidation;
}

export enum BloodGroup {
  A_POSITIVE = "A+",
  A_NEGATIVE = "A-",
  B_POSITIVE = "B+",
  B_NEGATIVE = "B-",
  ZERO_POSITIVE = "0+",
  ZERO_NEGATIVE = "0-",
  AB_POSITIVE = "AB+",
  AB_NEGATIVE = "AB-",
}
